/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Cart,
  CartItemCreateInput,
  CartItemUpdateInput,
  CartItemsBulkCreateInput,
  CartList,
  CartListCreateInput,
  CartListParams,
  CartListUpdateInput,
  CartListsList,
  CartParams,
  SchemaValidationErrorResponse,
  StandardError,
  SuccessResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Cart
 */
export const cart = (
    params?: MaybeRefOrGetter<CartParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Cart>(
      {url: `/cart`, method: 'GET',
        params, signal
    },
      );
    }




export const getCartQueryKey = (params?: MaybeRefOrGetter<CartParams>,) => {
    return [
    'cart', ...(params ? [params] : [])
    ] as const;
    }


export const getCartQueryOptions = <TData = Awaited<ReturnType<typeof cart>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<CartParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cart>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCartQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cart>>> = ({ signal }) => cart(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cart>>, TError, TData>
}

export type CartQueryResult = NonNullable<Awaited<ReturnType<typeof cart>>>
export type CartQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Cart
 */

export function useCart<TData = Awaited<ReturnType<typeof cart>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<CartParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cart>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCartQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Clear Cart
 */
export const clearCart = (

 signal?: AbortSignal
) => {


      return axiosClient<Cart>(
      {url: `/cart`, method: 'DELETE', signal
    },
      );
    }




export const getClearCartMutationKey = () => ['clearCart'] as const;

export const getClearCartMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCart>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clearCart>>, TError,void, TContext> => {

const mutationKey = getClearCartMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCart>>, void> = () => {


          return  clearCart()
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCartMutationResult = NonNullable<Awaited<ReturnType<typeof clearCart>>>

    export type ClearCartMutationError = ErrorType<unknown>


    /**
 * @summary Clear Cart
 */
export const useClearCart = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCart>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof clearCart>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getClearCartMutationOptions(options), queryClient);
    }
    /**
 * @summary Add Cart Item
 */
export const addCartItem = (
    cartItemCreateInput: MaybeRefOrGetter<CartItemCreateInput>,
 signal?: AbortSignal
) => {
      cartItemCreateInput = toValue(cartItemCreateInput);

      return axiosClient<Cart>(
      {url: `/cart/items`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cartItemCreateInput, signal
    },
      );
    }




export const getAddCartItemMutationKey = () => ['addCartItem'] as const;

export const getAddCartItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCartItem>>, TError,AddCartItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addCartItem>>, TError,AddCartItemMutationVariables, TContext> => {

const mutationKey = getAddCartItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCartItem>>, AddCartItemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addCartItem(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCartItemMutationResult = NonNullable<Awaited<ReturnType<typeof addCartItem>>>
    export type AddCartItemMutationBody = CartItemCreateInput
    export type AddCartItemMutationError = ErrorType<ValidationError | StandardError>
    export type AddCartItemMutationVariables = {data: CartItemCreateInput}

    /**
 * @summary Add Cart Item
 */
export const useAddCartItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCartItem>>, TError,AddCartItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addCartItem>>,
        TError,
        AddCartItemMutationVariables,
        TContext
      > => {
      return useMutation(getAddCartItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Add Cart Items
 */
export const addCartItems = (
    cartItemsBulkCreateInput: MaybeRefOrGetter<CartItemsBulkCreateInput>,
 signal?: AbortSignal
) => {
      cartItemsBulkCreateInput = toValue(cartItemsBulkCreateInput);

      return axiosClient<Cart>(
      {url: `/cart/items/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cartItemsBulkCreateInput, signal
    },
      );
    }




export const getAddCartItemsMutationKey = () => ['addCartItems'] as const;

export const getAddCartItemsMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCartItems>>, TError,AddCartItemsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addCartItems>>, TError,AddCartItemsMutationVariables, TContext> => {

const mutationKey = getAddCartItemsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCartItems>>, AddCartItemsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addCartItems(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCartItemsMutationResult = NonNullable<Awaited<ReturnType<typeof addCartItems>>>
    export type AddCartItemsMutationBody = CartItemsBulkCreateInput
    export type AddCartItemsMutationError = ErrorType<ValidationError | StandardError>
    export type AddCartItemsMutationVariables = {data: CartItemsBulkCreateInput}

    /**
 * @summary Add Cart Items
 */
export const useAddCartItems = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCartItems>>, TError,AddCartItemsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof addCartItems>>,
        TError,
        AddCartItemsMutationVariables,
        TContext
      > => {
      return useMutation(getAddCartItemsMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Cart Item
 */
export const updateCartItem = (
    id: MaybeRefOrGetter<string>,
    cartItemUpdateInput: MaybeRefOrGetter<CartItemUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
cartItemUpdateInput = toValue(cartItemUpdateInput);

      return axiosClient<Cart>(
      {url: `/cart/items/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cartItemUpdateInput, signal
    },
      );
    }




export const getUpdateCartItemMutationKey = () => ['updateCartItem'] as const;

export const getUpdateCartItemMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCartItem>>, TError,UpdateCartItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCartItem>>, TError,UpdateCartItemMutationVariables, TContext> => {

const mutationKey = getUpdateCartItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCartItem>>, UpdateCartItemMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateCartItem(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCartItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateCartItem>>>
    export type UpdateCartItemMutationBody = CartItemUpdateInput
    export type UpdateCartItemMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateCartItemMutationVariables = {id: string;data: CartItemUpdateInput}

    /**
 * @summary Update Cart Item
 */
export const useUpdateCartItem = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCartItem>>, TError,UpdateCartItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCartItem>>,
        TError,
        UpdateCartItemMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCartItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Remove Cart Item
 */
export const removeCartItem = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Cart>(
      {url: `/cart/items/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getRemoveCartItemMutationKey = () => ['removeCartItem'] as const;

export const getRemoveCartItemMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCartItem>>, TError,RemoveCartItemMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeCartItem>>, TError,RemoveCartItemMutationVariables, TContext> => {

const mutationKey = getRemoveCartItemMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCartItem>>, RemoveCartItemMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  removeCartItem(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCartItemMutationResult = NonNullable<Awaited<ReturnType<typeof removeCartItem>>>

    export type RemoveCartItemMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type RemoveCartItemMutationVariables = {id: string}

    /**
 * @summary Remove Cart Item
 */
export const useRemoveCartItem = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCartItem>>, TError,RemoveCartItemMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof removeCartItem>>,
        TError,
        RemoveCartItemMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveCartItemMutationOptions(options), queryClient);
    }
    /**
 * @summary Cart Lists
 */
export const cartLists = (

 signal?: AbortSignal
) => {


      return axiosClient<CartListsList>(
      {url: `/carts`, method: 'GET', signal
    },
      );
    }




export const getCartListsQueryKey = () => {
    return [
    'carts'
    ] as const;
    }


export const getCartListsQueryOptions = <TData = Awaited<ReturnType<typeof cartLists>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cartLists>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCartListsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cartLists>>> = ({ signal }) => cartLists(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cartLists>>, TError, TData>
}

export type CartListsQueryResult = NonNullable<Awaited<ReturnType<typeof cartLists>>>
export type CartListsQueryError = ErrorType<StandardError>


/**
 * @summary Cart Lists
 */

export function useCartLists<TData = Awaited<ReturnType<typeof cartLists>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cartLists>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCartListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Cart List
 */
export const createCartList = (
    cartListCreateInput: MaybeRefOrGetter<CartListCreateInput>,
 signal?: AbortSignal
) => {
      cartListCreateInput = toValue(cartListCreateInput);

      return axiosClient<CartList>(
      {url: `/carts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cartListCreateInput, signal
    },
      );
    }




export const getCreateCartListMutationKey = () => ['createCartList'] as const;

export const getCreateCartListMutationOptions = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCartList>>, TError,CreateCartListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createCartList>>, TError,CreateCartListMutationVariables, TContext> => {

const mutationKey = getCreateCartListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCartList>>, CreateCartListMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createCartList(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCartListMutationResult = NonNullable<Awaited<ReturnType<typeof createCartList>>>
    export type CreateCartListMutationBody = CartListCreateInput
    export type CreateCartListMutationError = ErrorType<ValidationError>
    export type CreateCartListMutationVariables = {data: CartListCreateInput}

    /**
 * @summary Create Cart List
 */
export const useCreateCartList = <TError = ErrorType<ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCartList>>, TError,CreateCartListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createCartList>>,
        TError,
        CreateCartListMutationVariables,
        TContext
      > => {
      return useMutation(getCreateCartListMutationOptions(options), queryClient);
    }
    /**
 * @summary Cart List
 */
export const cartList = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<CartListParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<Cart>(
      {url: `/carts/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getCartListQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<CartListParams>,) => {
    return [
    'carts',id, ...(params ? [params] : [])
    ] as const;
    }


export const getCartListQueryOptions = <TData = Awaited<ReturnType<typeof cartList>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<CartListParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cartList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCartListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cartList>>> = ({ signal }) => cartList(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cartList>>, TError, TData>
}

export type CartListQueryResult = NonNullable<Awaited<ReturnType<typeof cartList>>>
export type CartListQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Cart List
 */

export function useCartList<TData = Awaited<ReturnType<typeof cartList>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<CartListParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cartList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCartListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Cart List
 */
export const updateCartList = (
    id: MaybeRefOrGetter<string>,
    cartListUpdateInput: MaybeRefOrGetter<CartListUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
cartListUpdateInput = toValue(cartListUpdateInput);

      return axiosClient<CartList>(
      {url: `/carts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cartListUpdateInput, signal
    },
      );
    }




export const getUpdateCartListMutationKey = () => ['updateCartList'] as const;

export const getUpdateCartListMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCartList>>, TError,UpdateCartListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateCartList>>, TError,UpdateCartListMutationVariables, TContext> => {

const mutationKey = getUpdateCartListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCartList>>, UpdateCartListMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateCartList(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCartListMutationResult = NonNullable<Awaited<ReturnType<typeof updateCartList>>>
    export type UpdateCartListMutationBody = CartListUpdateInput
    export type UpdateCartListMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateCartListMutationVariables = {id: string;data: CartListUpdateInput}

    /**
 * @summary Update Cart List
 */
export const useUpdateCartList = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCartList>>, TError,UpdateCartListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateCartList>>,
        TError,
        UpdateCartListMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateCartListMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Cart List
 */
export const destroyCartList = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<SuccessResponse>(
      {url: `/carts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyCartListMutationKey = () => ['destroyCartList'] as const;

export const getDestroyCartListMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyCartList>>, TError,DestroyCartListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyCartList>>, TError,DestroyCartListMutationVariables, TContext> => {

const mutationKey = getDestroyCartListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyCartList>>, DestroyCartListMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyCartList(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyCartListMutationResult = NonNullable<Awaited<ReturnType<typeof destroyCartList>>>

    export type DestroyCartListMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyCartListMutationVariables = {id: string}

    /**
 * @summary Destroy Cart List
 */
export const useDestroyCartList = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyCartList>>, TError,DestroyCartListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyCartList>>,
        TError,
        DestroyCartListMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyCartListMutationOptions(options), queryClient);
    }
    /**
 * @summary Clear Cart List
 */
export const clearCartList = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Cart>(
      {url: `/carts/${id}/items`, method: 'DELETE', signal
    },
      );
    }




export const getClearCartListMutationKey = () => ['clearCartList'] as const;

export const getClearCartListMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCartList>>, TError,ClearCartListMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof clearCartList>>, TError,ClearCartListMutationVariables, TContext> => {

const mutationKey = getClearCartListMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof clearCartList>>, ClearCartListMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  clearCartList(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ClearCartListMutationResult = NonNullable<Awaited<ReturnType<typeof clearCartList>>>

    export type ClearCartListMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type ClearCartListMutationVariables = {id: string}

    /**
 * @summary Clear Cart List
 */
export const useClearCartList = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof clearCartList>>, TError,ClearCartListMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof clearCartList>>,
        TError,
        ClearCartListMutationVariables,
        TContext
      > => {
      return useMutation(getClearCartListMutationOptions(options), queryClient);
    }
